import type { ConversationNodeAutoReply } from 'lib-shared-types-api';

type RoutedThroughAutoReplyProps = {
  node: ConversationNodeAutoReply;
};

export function RoutedThroughAutoReply({
  node,
}: RoutedThroughAutoReplyProps): JSX.Element {
  return (
    <>
      Auto-reply · Template <strong>{node.auto_reply_template_id}</strong> sent
    </>
  );
}
